import React from 'react';
import PropTypes from 'prop-types';
import { MAIN_COLOR } from '../../../styles/variables';

const CheckedIcon = ({ color, size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 30 30"
    >
      <defs>
        <path
          id="CheckedIconA"
          d="M15 25.4c5.744 0 10.4-4.656 10.4-10.4 0-5.744-4.656-10.4-10.4-10.4C9.256 4.6 4.6 9.256 4.6 15c0 5.744 4.656 10.4 10.4 10.4zm0 1.6C8.373 27 3 21.627 3 15S8.373 3 15 3s12 5.373 12 12-5.373 12-12 12zm4.747-16.658a1 1 0 1 1 1.506 1.317l-7 8a1 1 0 0 1-1.46.048l-4-4a1 1 0 0 1 1.414-1.414l3.244 3.244 6.296-7.195z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="CheckedIconB" fill="#fff">
          <use xlinkHref="#CheckedIconA" />
        </mask>
        <use fill={color || MAIN_COLOR} fillRule="nonzero" xlinkHref="#CheckedIconA" />
        <g fill={color || MAIN_COLOR} mask="url(#CheckedIconB)">
          <path d="M0 0h30v30H0z" />
        </g>
      </g>
    </svg>
  );
};

CheckedIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

CheckedIcon.defaultProps = {
  color: MAIN_COLOR,
  size: '90px',
};

export default CheckedIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Checked/index.js